import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../lib/axios";
import { API_PORTAL_URL } from "../lib/config";
// import { SuccessToast } from "../components/common/Toast";

export const getAllActiveEvent = createAsyncThunk(
  "Events/FindAllActiveEvents",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Events/FindAllActiveEvents`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Active Event:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export async function fetchAllActiveEvent() {
  try {
    const res = await fetch(`${API_PORTAL_URL}/Events/FindAllActiveEvents`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      next: { revalidate: 30 },
    });
    const json = await res.json();
    return json.Data ?? [];
  } catch {
    return [];
  }
}

export async function fetchEventDetailsByURL(URL: string) {
  try {
    const res = await fetch(`${API_PORTAL_URL}/Events/FindByURLEvents`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ URL }),
      next: { revalidate: 30 },
    });
    const json = await res.json();
    return json.Data ?? null;
  } catch {
    return null;
  }
}

export async function fetchAllActiveEventSpace() {
  try {
    const res = await fetch(
      `${API_PORTAL_URL}/EventSpace/FindAllActiveEventSpace`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        next: { revalidate: 30 },
      },
    );
    const json = await res.json();
    return json.Data ?? [];
  } catch {
    return [];
  }
}
